export default {
  inri: {
    common: {
      yes: 'Oui',
    },
  },
}
